export type AllergiesPopulateOutcome = {
  created?: number;
  updated?: number;
  reactionsReplaced?: number;
  reactionsMerged?: number;
  unchanged?: number;
};

export function getAllergiesPopulateNotification(result: {
  data?: AllergiesPopulateOutcome;
  created?: number;
  updated?: number;
  reactionsReplaced?: number;
  reactionsMerged?: number;
  unchanged?: number;
  message?: string;
}): { message: string; variant: "success" | "warning" | "error" } {
  const outcome = result?.data ?? result;
  const created = outcome?.created ?? 0;
  const updated = outcome?.updated ?? 0;
  const reactionsReplaced = outcome?.reactionsReplaced ?? 0;
  const reactionsMerged = outcome?.reactionsMerged ?? 0;

  if (created > 0 || updated > 0) {
    const parts: string[] = [];
    if (created > 0) parts.push(`${created} created`);
    if (reactionsReplaced > 0) {
      parts.push(
        `${reactionsReplaced} reaction${reactionsReplaced === 1 ? "" : "s"} replaced`,
      );
    }
    if (reactionsMerged > 0) {
      parts.push(
        `${reactionsMerged} reaction${reactionsMerged === 1 ? "" : "s"} merged`,
      );
    } else if (updated > 0 && reactionsReplaced === 0) {
      parts.push(`${updated} updated`);
    }
    return {
      message: `Allergies populated successfully (${parts.join(", ")})`,
      variant: "success",
    };
  }

  return {
    message:
      result?.message ||
      "No new allergies to apply — they may already exist on the chart",
    variant: "warning",
  };
}
